import { faClipboardCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useRef, useState } from "react";
import { RiAdminFill } from "react-icons/ri";
import Authentication from "../../../../libs/api/services/Authentication";
import Questionnaire from "../../../../libs/api/services/Questionnaire";
import QuestionnaireAssignment from "../../../../libs/api/services/QuestionnaireAssignment";
import QuestionnaireBasic from "../../../../libs/api/services/QuestionnaireBasic";
import WorkFlow from "../../../../libs/api/services/WorkFlow";
import Drawer from "./components/Drawer";
import AdminContainer from "./components/containers/AdminContainer";
import NewComponentContainer from "./components/containers/NewComponentContainer";
import SectionContainer from "./components/containers/SectionContainer";

import { NavigationButtons } from "./navigation/NavigationButtons";
import SectionsDropDown from "./navigation/SectionsDropDown";
// [✅] Component should support multiple layouts primarily wizard and form layouts.
// [✅]It has different sections with components for each section.
// [✅] The form wizards shows each section one by one, while the form layout shows all sections at once.
// [✅] The wizard has back next and done buttons, while the form layout has a submit button.

// [✅] Components should be laid out on a grid system, with each component taking up a certain number of columns.

// [✅] Component authorization should be added for view, edit or admin permissions.

// Components types to be supported:
// - Text
// - RTF Editor
// - TextInput
// - single select
// - multi select
// - date picker
// - IDC10
// - Component table which contains a list of components and can have additional rows added by theh user for additinoal line entries

// There should also be the ability to have sub sections which are collapsible and can be expanded to show more components based on if a component option is selected or not.

// Admin components
// Allow the admin user to
//  - Enter the question name
//  - Select if the component is required

export function DEBUG(data) {
  const debug = true;
  if (debug) console.log(data);
}

export default function QuestionnaireCanvas({
  questionnaireId,
  assignmentId,
  platform = 'questionnaire', // form / questionnaire
  extra: {
    anonymousAssignment = false,
    mode = undefined, // admin, undefined,explore
    accessTypes = ["View", "Edit", "Admin"],
  } = {},
}) {
  const _assignementid = useRef(assignmentId);
  const _assignementTo = useRef(undefined);
  const [version, setVersion] = useState(new Date().getTime());
  const [currentStep, setCurrentStep] = useState(1);
  const [sections, setSections] = useState([]);
  const [questionnaireData, setQuestionnaireData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [questionnaireOptions, setQuestionnaireOptions] = useState({
    layoutType: "Wizard Layout", // Form Layout, Wizard Layout
    theme: "default",
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerContent, setDrawerContent] = useState(null);
  const [showAdminOverview, setShowAdminOverview] = useState(false);
  const [showCompletionModal, setShowCompletionModal] = useState(false);

  // Validation function for a single component
  const validateComponent = (component, value) => {
    const isRequired = component.required;
    if (typeof value === "string") {
      if (isRequired && (!value || value === "")) {
        return "This field is required.";
      }
    } else if (
      typeof value === "object" &&
      Object.keys(value).includes("value")
    ) {
      if (
        isRequired &&
        (!value.value ||
          typeof value.value === "undefined" ||
          value.value === "")
      ) {
        return "This field is required.";
      }
    } else if (isRequired && (typeof value === "undefined" || value === "")) {
      return "This field is required.";
    }
    return "";
  };

  // Validate all components in the current section(s) - PURE, no state update
  const validateCurrentSection = (sectionIdx, type) => {
    DEBUG(
      `Validating section ${sectionIdx} for questionnaire ${questionnaireId} ${mode} ${questionnaireOptions.layoutType}`
    );
    if (mode === "Discover") return true;
    const section =
      sections[type === "Wizard Layout" ? sectionIdx - 1 : sectionIdx];
    DEBUG(
      `Validating section (99) Sections Length ${sections.length} Section ${section} sectionIdx ${sectionIdx} components:`,
      section?.components
    );
    if (!section) return false;
    let valid = true;
    let i = 0;
    section.components.forEach((comp) => {
      const value = questionnaireData[comp.componentId];
      const error = validateComponent(comp, value);
      DEBUG(
        `Validating component ${i++} ${section.components.length} ${comp.componentId
        }:`,
        value,
        error,
        !error && "No Err",
        error,
        comp
      );
      // If there is an
      // DEBUG(`Validating component ${i ++} ${section.components.length} ${comp.componentId}:`, value, error, !error && 'No Err', error,comp);
      if (error) valid = false;
    });
    return valid;
  };

  // Update validation errors for a section (called on user complete or navigation)
  const updateValidationErrorsForSection = (sectionIdx) => {
    if (mode === "Discover") return; // No validation in discover mode
    const section = sections[sectionIdx];
    if (!section) return;
    const newErrors = { ...validationErrors };
    section.components.forEach((comp) => {
      const value = questionnaireData[comp.componentId];
      const error = validateComponent(comp, value);
      newErrors[comp.componentId] = error;
    });
    setValidationErrors(newErrors);
  };

  // Load the questionnaire data from the API or state management.
  // const loadQuestionnaireData = async () => {
  //     if (anonymousAssignment && !assignmentId) {
  //         console.warn('Anonymous assignment detected, using default assignment ID.');
  //         assignmentId = 'anonymous'; // Use a default value for anonymous assignments
  //     }
  //     if (!assignmentId || !questionnaireId) {
  //         console.error('Assignment ID and Questionnaire ID are required to load the questionnaire data.');
  //         return;
  //     }

  //     DEBUG(`Loading questionnaire data for assignment ID: ${assignmentId}, questionnaire ID: ${questionnaireId}`);
  //     const Questionnaire = await QuestionnaireBasic.LoadQuestionnaire(questionnaireId);
  //     if (!Questionnaire) {
  //         console.error(`No questionnaire found for ID: ${questionnaireId}`);
  //         return;
  //     }
  //     DEBUG('Questionnaire data loaded:', Questionnaire);
  //     // Transform the sections into a format that can be used by the questionnaire components
  //     setSections((Questionnaire.sections || []).map(section => ({
  //         id: section.id,
  //         title: section.name,
  //         components: section.components.map((component, index) => ({
  //             componentId: component.id,
  //             componentType: component.componentType.type,
  //             layout: component.properties.find(a => a.property === 'Layout')?.values ?
  //                 JSON.parse(component.properties.find(a => a.property === 'Layout').values) :
  //                 { x: 0, y: index, w: 12, h: 2 }, // Default layout if not specified
  //             question: component.properties.find(a => a.property === 'Question')?.values ?
  //                 component.properties.find(a => a.property === 'Question').values :
  //                 { x: 0, y: index, w: 12, h: 2 }, // Default layout if not specified
  //             required: component.properties.find(a => a.property === 'Required')?.values ?
  //                 JSON.parse(component.properties.find(a => a.property === 'Required').values) : false,

  //             properties: component.properties.filter(a => (a.property !== 'Layout' && a.property !== 'Question')).length > 0 ?
  //                 component.properties.filter(a => (a.property !== 'Layout' && a.property !== 'Question'))
  //                 : { x: 0, y: index, w: 12, h: 2 }, // Default layout if not specified
  //         })) || [],
  //     })));
  //     // setQuestionnaireData(data); // If you want to set initial data
  // };

  // handlers for user interactions
  // User inputing data into a component
  const handleUserInput = async (componentId, value) => {
    // Call QuestionnaireResponse and get the responseId
    let responseId = null;
    try {
      console.log(`handleUserInput: ${componentId}, ${value}`, {
        answerType: { id: componentId },
        answer: value,
      })
      const response = await Questionnaire.QuestionnaireResponse(
        _assignementid.current,
        {
          answerType: { id: componentId },
          answer: value,
        }
      ).catch((err) => {
        console.error("Error in QuestionnaireResponse:", err);
      });
      responseId = response?.id || null;
    } catch (e) {
      responseId = null;
    }
    setQuestionnaireData((prev) => ({
      ...prev,
      [componentId]: {
        questionnaireResponseId: responseId,
        value,
      },
    }));
    // Optionally, clear error on input
    setValidationErrors((prev) => ({ ...prev, [componentId]: "" }));

    // Questionnaire.QuestionnaireResponse(assignmentId, {
    //     answerType:{
    //         id: componentId
    //     },
    //     answer: value
    // })
  };
  // User completed entering data into a component
  const handleUserCompleted = (componentId) => {
    const comp = sections
      .flatMap((s) => s.components)
      .find((c) => c.componentId === componentId);
    const value = questionnaireData[componentId];
    // Send the value to the API
    const error = validateComponent(comp, value);
    setValidationErrors((prev) => {
      if (prev[componentId] === error) return prev;
      return { ...prev, [componentId]: error };
    });
  };

  const handleQuestionnaireStarted = () => {
    if (mode === "Discover") return;
    // Trigger automation for questionnaire started
    DEBUG(`Trigger Questionnaire started`, {
      facility: String(Authentication.getFacility()),
      assignment: String(_assignementid.current),
      InitiatedFor: String(_assignementTo.current),
    });
    if (_assignementTo.current)
      WorkFlow.TriggerAutomation("Questionnaire", "QUESIONNAIRE_STARTED", {
        facility: String(Authentication.getFacility()),
        assignment: String(_assignementid.current),
        InitiatedFor: String(_assignementTo.current),
      });
    else
      console.warn(
        "Questionnaire stated but no assignmentTo set, cannot trigger automation."
      );
  };

  useEffect(() => {
    const reuseQuad = false; // Check is working
    DEBUG("QuestionnaireCanvas mounted");
    const loadQuestionnaireData = async () => {
      if (mode === "admin") {
        DEBUG("Loading questionnaire in admin mode");
        if (!questionnaireId) {
          console.error("Questionnaire ID is required in admin mode.");
          return;
        }
        // Load questionnaire data for admin mode
        const _QuestionnaireFull = await Questionnaire.GetQuestionnaireSecure(
          questionnaireId
        );
        if (!_QuestionnaireFull) {
          console.error(`No questionnaire found for ID: ${questionnaireId}`);
          return;
        }
        // No anwers to load, just the questionnaire structure
        const _Questionnaire = await _QuestionnaireFull;
        DEBUG("Questionnaire data loaded:", _Questionnaire);
        if (!_Questionnaire) {
          console.error(
            `No questionnaire found in the response for ID: ${questionnaireId}`
          );
          return;
        }
        DEBUG("Questionnaire data loaded:", _Questionnaire);
        let layout = "Form Layout";
        try {
          layout = _Questionnaire.resource.resource.layout.layout;
        } catch (e) {
          console.warn(
            `No layout specified for questionnaire ${questionnaireId}, using default layout.`
          );
        }
        DEBUG("Questionnaire layout:", layout);

        setQuestionnaireOptions({
          layoutType: layout ?? "Form Layout",
          name: _Questionnaire.resource.resource.name,
        });
        DEBUG(
          "Sections loaded Resources:",
          _Questionnaire.resources.length,
          _Questionnaire.resources
        );
        // Transform the sections into a format that can be used by the questionnaire components
        setSections(
          (_Questionnaire.resources || []).map((resource) => ({
            id: resource.resource.resource.id,
            order: resource.resource.resource.order,
            title: resource.resource.resource.name,
            accessTypes: resource.resource.accessTypes,
            components:
              resource.resources.map((componentResource, index) => ({
                accessTypes: componentResource.AccessTypes,
                componentId: componentResource.resource.id,
                order: componentResource.resource.order,
                componentType: componentResource.resource.componentType
                  ? componentResource.resource.componentType.type
                  : "New",
                layout: componentResource.resource.properties.find(
                  (a) => a.property === "Layout"
                )?.values
                  ? JSON.parse(
                    componentResource.resource.properties.find(
                      (a) => a.property === "Layout"
                    ).values
                  )
                  : { x: 0, y: index, w: 12, h: 10 }, // Default layout if not specified
                question: componentResource.resource.properties.find(
                  (a) => a.property === "Question"
                )?.values
                  ? componentResource.resource.properties.find(
                    (a) => a.property === "Question"
                  ).values
                  : { x: 0, y: index, w: 12, h: 10 }, // Default layout if not specified
                required: componentResource.resource.properties.find(
                  (a) => a.property === "Required"
                )?.values
                  ? JSON.parse(
                    componentResource.resource.properties.find(
                      (a) => a.property === "Required"
                    ).values
                  ) ?? false
                  : false,
                properties:
                  componentResource.resource.properties.filter(
                    (a) => a.property !== "Layout" && a.property !== "Question"
                  ).length > 0
                    ? componentResource.resource.properties.filter(
                      (a) =>
                        a.property !== "Layout" && a.property !== "Question"
                    )
                    : { x: 0, y: index, w: 12, h: 10 }, // Default layout if not specified
              })) || [],
          }))
        );
        DEBUG("Sections loaded:", _Questionnaire.resources);
        setIsLoading(false);
        return;
      } else {
        DEBUG("Loading questionnaire in user mode");
        let effectiveAssignmentId = assignmentId;
        if (anonymousAssignment && !assignmentId) {
          console.warn(
            "Anonymous assignment detected, using default assignment ID."
          );

          const QAID = localStorage.getItem("QAID");
          if (reuseQuad && QAID !== null) {
            effectiveAssignmentId = QAID;
          } else {
            if (QAID !== null)
              await QuestionnaireAssignment.RemoveColdRequest(
                questionnaireId,
                QAID
              ).catch((err) => {
                console.error("Error removing cold request:", err);
              });

            const res = await QuestionnaireAssignment.NewColdRequest(
              questionnaireId
            ).catch((err) => {
              console.error("Error creating new cold request:", err);
              return null;
            });

            localStorage.setItem("QAID", res.id);
            effectiveAssignmentId = res.id; // Use local variable instead of assignmentId
          }
        }
        if (!effectiveAssignmentId || !questionnaireId) {
          console.error(
            `Assignment ID and Questionnaire ID are required to load the questionnaire data. ${assignmentId} ${effectiveAssignmentId} ${questionnaireId}`
          );
          return;
        }
        _assignementid.current = effectiveAssignmentId; // Update the ref with the effective assignment ID
        DEBUG(
          `Loading questionnaire data for assignment ID: ${effectiveAssignmentId}, questionnaire ID: ${questionnaireId}`
        );

        // const _Questionnaire = await QuestionnaireBasic.LoadQuestionnaire(questionnaireId);
        const _QuestionnaireFull =
          await Questionnaire.GetQuestionnaireResultsFull(
            _assignementid.current
          );
        if (!_QuestionnaireFull) {
          console.error(`No questionnaire found for ID: ${questionnaireId}`);
          return;
        }

        _assignementTo.current = _QuestionnaireFull.assignedTo.id;
        DEBUG(
          `Questionnaire data loaded for assignment ID: ${_assignementid.current}, questionnaire ID`
        );
        // Load existing answers if any
        const existing = _QuestionnaireFull.responses.reduce(
          (acc, response) => {
            if (!response.answerType || !response.answerType.id) {
              console.warn(
                `Response ${response.id} does not have a valid answerType or id, skipping.`
              );
              return acc;
            }
            acc[response.answerType.id] = {
              questionnaireResponseId: response.id,
              value: response.answer,
            };
            return acc;
          },
          {}
        );
        DEBUG("Existing questionnaire data loaded:", existing);
        setQuestionnaireData(existing);
        // Main access on questionnaire
        // const AccessTypes = _QuestionnaireFull.questionnaire.resource.accessTypes || [];

        const _Questionnaire = _QuestionnaireFull.questionnaire;
        if (!_Questionnaire) {
          console.error(
            `No questionnaire found in the response for ID: ${questionnaireId}`
          );
          return;
        }
        if (
          !_Questionnaire.resource.resource.layout ||
          !_Questionnaire.resource.resource.layout.layout
        ) {
          DEBUG(
            `No layout specified for questionnaire ${questionnaireId}, using default layout.`
          );
          _Questionnaire.resource.resource.layout = {
            layout: "Form Layout",
          };
        }
        setQuestionnaireOptions({
          layoutType:
            _Questionnaire.resource.resource.layout.layout ?? "Form Layout",
          name: _Questionnaire.resource.resource.name,
        });

        // DEBUG("Questionnaire data loaded:", _Questionnaire);
        // DEBUG("Sections loaded:", _Questionnaire.resources);
        console.log(_Questionnaire.resources)
        setSections(
          (_Questionnaire.resources || []).map((resource) => ({
            id: resource.resource.resource.id,
            order: resource.resource.resource.order,
            title: resource.resource.resource.name,
            accessTypes: resource.resource.accessTypes,
            components:
              resource.resources.map((componentResource, index) => ({
                accessTypes: componentResource.AccessTypes,
                componentId: componentResource.resource.id,
                order: componentResource.resource.order,
                componentType: componentResource.resource.componentType ? componentResource.resource.componentType.type : "Unknown",
                layout: (Array.isArray(componentResource.resource?.properties) &&
                  componentResource.resource.properties.find((a) => a.property === "Layout")?.values)
                  ? JSON.parse(componentResource.resource.properties.find((a) => a.property === "Layout").values)
                  : { x: 0, y: index, w: 12, h: 10 }, // Default layout if not specified

                question: (Array.isArray(componentResource.resource?.properties) &&
                  componentResource.resource.properties.find((a) => a.property === "Question")?.values)
                  ? componentResource.resource.properties.find((a) => a.property === "Question").values
                  : undefined,

                required: (Array.isArray(componentResource.resource?.properties) &&
                  componentResource.resource.properties.find((a) => a.property === "Required")?.values)
                  ? (JSON.parse(componentResource.resource.properties.find((a) => a.property === "Required").values) ?? false)
                  : false,

                properties: Array.isArray(componentResource.resource?.properties)
                  ? componentResource.resource.properties.filter((a) => a.property !== "Layout" && a.property !== "Question")
                  : [],
              })) || [],
          }))
        );
      }

      handleQuestionnaireStarted();
      setIsLoading(false);
    };
    loadQuestionnaireData();
  }, [anonymousAssignment, assignmentId, questionnaireId, mode, version]);

  // Admin related stuff

  const handleUpdateComponentProperty = (
    sectionId,
    componentId,
    property,
    values,
    serialize
  ) => {
    DEBUG(
      `Updating component property: ${property} for component ID: ${componentId} in section ID: ${sectionId}`,
      sectionId,
      componentId,
      property,
      values,
      serialize
    );
    // Update API
    QuestionnaireBasic.SetComponentProperty(
      questionnaireId,
      sectionId,
      componentId,
      property,
      values,
      serialize
    );
    // Update session
    setSections((prevSections) =>
      prevSections.map((section) => ({
        ...section,
        components: section.components.map((comp) => {
          if (comp.componentId === componentId) {
            // Update the property in the component
            if (property === "Question") {
              return { ...comp, question: values };
            } else if (property === "Required") {
              return { ...comp, required: values };
            } else {
              // For other properties, update in the properties array
              const updatedProperties = Array.isArray(comp.properties)
                ? comp.properties.map((p) =>
                  p.property === property ? { ...p, values } : p
                )
                : comp.properties;
              return { ...comp, properties: updatedProperties };
            }
          }
          return comp;
        }),
      }))
    );
    DEBUG("handleUpdateComponentProperty");
    return Promise.resolve();
  };

  const handleChangeLayout = useCallback(
    async (section, layout) => {
      DEBUG(
        `Changing layout for section ${section.id} to ${layout}`,
        section,
        layout
      );
      for (let i = 0; i < section.components.length; i++) {
        DEBUG(
          `Updating layout for component ${section.components[i].componentId} to ${layout}`
        );
        await QuestionnaireBasic.UpdateComponentLayout(
          questionnaireId,
          section.id,
          section.components[i].componentId,
          {
            x: layout[i].x,
            y: layout[i].y,
            w: layout[i].w,
            h: layout[i].h,
            minW: layout[i].minW,
            minH: layout[i].minH,
          }
        ).catch((err) => {
          console.error(
            `Error updating layout for component ${section.components[i].componentId}:`,
            err
          );
        });
        // Update the component layout in the state
      }
    },
    [questionnaireId]
  );

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  const handleNext = () => {
    updateValidationErrorsForSection(currentStep);
    if (currentStep >= sections.length) {
      console.warn("No more steps available, cannot go to next step.");
      return;
    }
    setCurrentStep(currentStep + 1);
  };
  const handleDone = async () => {
    if (mode === "Discover") return;
    updateValidationErrorsForSection(currentStep);
    // Login user if registration
    if (
      questionnaireOptions.name === "Login - Registration Form" &&
      _assignementTo.current
    ) {
      await Authentication.onboardUser({
        userId: _assignementTo.current,
        accessKey: "^&jjj555&&6%^3#2hs8844858_0998&4@",
      })
        .then(() => {
          DEBUG("User onboarded successfully.");
        })
        .catch((err) => {
          console.error("Error onboarding user:", err);
        });
    }
    // Trigger work flow automation for questionnaire completed
    WorkFlow.TriggerAutomation("Questionnaire", "QUESIONNAIRE_COMPLETED", {
      facility: String(Authentication.getFacility()),
      assignment: String(_assignementid.current),
      InitiatedFor: String(_assignementTo.current),
    }).catch((err) => {
      console.error(
        "Error triggering questionnaire completed automation:",
        err
      );
    });

    // Show a confirmation dialog or message
    QuestionnaireAssignment.CompleteQuestionnaire(_assignementid.current)
      .then(() => {
        setShowCompletionModal(true);
      })
      .catch((err) => {
        console.error("Error completing questionnaire:", err);
      });
    DEBUG("Questionnaire submitted:", questionnaireData);
  };

  // Determine if Next/Done should be disabled
  const isCurrentSectionValid = () => {
    DEBUG(
      `Validating current section ${currentStep} for questionnaire ${questionnaireId} ${mode} ${questionnaireOptions.layoutType}`
    );

    if (mode === "Discover") return true; // No validation in discover mode
    let valid = true;
    if (questionnaireOptions.layoutType === "Wizard Layout") {
      // Check for errors in validationErrors for current section
      const section = sections[currentStep - 1];
      if (section) {
        for (const comp of section.components) {
          if (validationErrors[comp.componentId]) valid = false;
        }
      }
      // Also check if all required fields are filled
      DEBUG(
        `Validating section ${currentStep}:`,
        section,
        validateCurrentSection(currentStep, questionnaireOptions.layoutType)
      );
      if (!section) return false; //
      if (!validateCurrentSection(currentStep, questionnaireOptions.layoutType))
        valid = false;

      return valid;
    } else {
      // form layout: check all sections
      for (let idx = 0; idx < sections.length; idx++) {
        const section = sections[idx];
        if (section) {
          for (const comp of section.components) {
            if (validationErrors[comp.componentId]) valid = false;
          }
        }
        if (!validateCurrentSection(idx, questionnaireOptions.layoutType))
          valid = false;
      }
      return valid;
    }
  };

  const tryTranslateRTF = (text) => {
    if (
      text.startsWith('"{') &&
      text.endsWith('}"') &&
      text.includes('\\"text\\"')
    ) {
      try {
        return JSON.parse(JSON.parse(text))
          .blocks.reduce((acc, block) => {
            if (block.text) {
              acc.push(block.text);
              return acc;
            }
          }, [])
          .join(" ");
      } catch (e) {
        // return "??";
      }
    }
    return text;
  };
  // Handler to open the drawer for admin overview
  const handleOpenAdminOverview = () => {
    setDrawerContent(
      <div>
        <h3>Questionnaire Overview</h3>
        <pre
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-all",
            textAlign: "left",
          }}
        >
          {/* {JSON.stringify(
            { questionnaireId, sections, questionnaireOptions },
            null,
            2
          )} */}
        </pre>
        <h4>Calculations</h4>
        {sections.map((section, index) => (
          <div key={section.id}>
            <h4>
              Section {index + 1}: {section.title}
            </h4>
            <ul>
              {section.components &&
                // section.components.filter(a => a.properties.property === 'Options').map((component) => (
                section.components.map((component) => (
                  <li key={component.componentId}>
                    {component.question &&
                      typeof component.question === "string" &&
                      tryTranslateRTF(component.question)}
                    {/* {component.componentId} - {component.componentType}{" "} */}
                    {component.required ? "(Required)" : "(Optional)"}
                    {
                      component.properties &&
                      Array.isArray(component.properties) &&
                      component.properties.find(
                        (a) => a.property === "Options"
                      ) &&
                      JSON.parse(
                        component.properties.find(
                          (a) => a.property === "Options"
                        ).values
                      ).map(
                        (opt) => (
                          <div className="d-flex justify-content-between">
                            {opt.option}{" "}
                            <small>
                              {" "}
                              {opt.weight} <i>weight</i>{" "}
                            </small>{" "}
                          </div>
                        )
                        // JSON.stringify(opt)
                      )
                      // .join(", ")
                      // .map((opt) => JSON.stringify(opt.values))
                    }
                  </li>
                ))}
            </ul>
          </div>
        ))}
        <div>
          <b>Total Required Fields: </b>
          {sections.reduce(
            (acc, sec) => acc + sec.components.filter((c) => c.required).length,
            0
          )}
        </div>

        <b>Total Weight: </b>
        {sections.reduce((acc, sec) => {
          sec.components.forEach((c) => {
            if (c.properties && Array.isArray(c.properties)) {
              const options = c.properties.find(
                (a) => a.property === "Options"
              );
              if (options && options.values) {
                const parsedOptions = JSON.parse(options.values);
                // Find the max weight in the options array
                const maxWeight = parsedOptions.reduce((max, opt) => {
                  if (!isNaN(opt.weight)) {
                    const w = (opt.weight && parseInt(opt.weight)) || 0;
                    return w > max ? w : max;
                  }
                  return max;
                }, 0);
                acc += maxWeight;
              }
            }
          });
          return acc;
        }, 0)}
        {/* Add more calculations as needed */}
      </div>
    );
    setDrawerOpen(true);
  };
  // Handler to open the drawer for editing a component
  const handleEditComponent = (component) => {
    // Listen for drawer switch event from AdminContainer
    if (typeof window !== "undefined" && window.addEventListener) {
      window.addEventListener(
        "hideDrawer",
        (e) => {
          setDrawerOpen(false);
          setDrawerContent(null);
        },
        { once: true }
      );
    }
    if (typeof window !== "undefined" && window.addEventListener) {
      window.addEventListener(
        "showNewComponentDrawer",
        (e) => {
          setDrawerContent(
            <NewComponentContainer
              onPropertyChange={(componentId, property, value, serialize) =>
                handleUpdateComponentProperty(
                  section ? section.id : null,
                  componentId,
                  property,
                  value,
                  serialize
                )
              }
              component={component}
              ComponentChange={() => setVersion(new Date().getTime())}
              onComponentTypeSelected={handleComponentTypeSelected}
            />
          );
        },
        { once: true }
      );
    }
    const section = sections.find((sec) =>
      sec.components.some((c) => c.componentId === component.componentId)
    );

    // Callback to switch to AdminContainer when type is selected
    const handleComponentTypeSelected = (selectedComponent) => {
      setDrawerContent(
        <AdminContainer
          onPropertyChange={(componentId, property, value, serialize) =>
            handleUpdateComponentProperty(
              section ? section.id : null,
              componentId,
              property,
              value,
              serialize
            )
          }
          component={selectedComponent}
          onComponentChange={() => setVersion(new Date().getTime())}
        />
      );
    };

    if (component && component.componentType === "New") {
      setDrawerContent(
        <NewComponentContainer
          onPropertyChange={(componentId, property, value, serialize) =>
            handleUpdateComponentProperty(
              section ? section.id : null,
              componentId,
              property,
              value,
              serialize
            )
          }
          component={component}
          ComponentChange={() => setVersion(new Date().getTime())}
          onComponentTypeSelected={handleComponentTypeSelected}
        />
      );
    } else {
      setDrawerContent(
        <AdminContainer
          onPropertyChange={(componentId, property, value, serialize) =>
            handleUpdateComponentProperty(
              section ? section.id : null,
              componentId,
              property,
              value,
              serialize
            )
          }
          component={component}
          onComponentChange={() => setVersion(new Date().getTime())}
        />
      );
    }
    setDrawerOpen(true);
  };
  // Handler to close the drawer
  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setDrawerContent(null);
  };

  if (!isLoading) {
    // Placeholder for fallbacks
    // } else if (isLoading || !sections.length > 0) {
  } else if (isLoading) {
    // Show a loading spinner or message while the questionnaire data is being loaded
    return (
      <div
        className="d-flex h-100 w-100 flex-column align-items-center justify-content-center text-center position-relative"
        style={{ minHeight: "50vh" }}
      >
        <FontAwesomeIcon icon={faClipboardCheck} size="4x" className=" mb-3" />
        <b>Getting questionnaire ready</b>
        <FontAwesomeIcon icon={faSpinner} spin className=" m-3" />
      </div>
    );
  }

  return (
    <div
      className="d-flex flex-column h-100 flex-grow-1 "
      style={{ maxHeight: "100%" }}
    >
      {mode === "admin" && (
        <div className={`position-absolute end-0 p-1 shadow ${platform === 'questionnaire' ? 'bg-secondary-container' : ''} rounded-3 d-flex`}>
          <button onClick={handleOpenAdminOverview}>
            <RiAdminFill /> Admin Options
          </button>
          <SectionsDropDown
            questionnaireId={questionnaireId}
            onUpdate={() => setVersion(new Date().getTime())}
          />
        </div>
      )}
      <div
        className="flex-grow-1 text-start d-flex flex-column"
        style={{ overflowY: "auto", overflowX: "hidden" }}
      >
        <SectionContainer
          handleNext={handleNext}
          handleDone={handleDone}
          handleChangeLayout={handleChangeLayout}
          handleUserInput={handleUserInput}
          handleUserInputComplete={handleUserCompleted}
          layout={questionnaireOptions.layoutType}
          currentStep={currentStep}
          sections={sections}
          validationErrors={validationErrors}
          onEditComponent={handleEditComponent}
          questionnaireData={questionnaireData}
          onAddComponent={() => setVersion(new Date().getTime())}
          platform={platform}
        />
      </div>
      <NavigationButtons
        layoutType={questionnaireOptions.layoutType}
        currentStep={currentStep}
        stepsSize={sections.length}
        isAdmin={mode === "admin"}
        onBack={handleBack}
        onNext={handleNext}
        onDone={handleDone}
        disabled={!isCurrentSectionValid()}
      />
      {/* Drawer for any content */}
      <Drawer
        open={drawerOpen && !!drawerContent}
        onClose={handleCloseDrawer}
        width={400}
      >
        {drawerContent}
      </Drawer>
      {showCompletionModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
              padding: "32px 24px",
              minWidth: "320px",
              textAlign: "center",
            }}
          >
            <FontAwesomeIcon
              icon={faClipboardCheck}
              size="3x"
              className="mb-3"
            />
            <h3>Questionnaire Completed</h3>
            <p>Your responses have been submitted successfully.</p>
            <button
              className="btn btn-primary mt-3"
              onClick={() => (window.location.href = "/")}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
